"use strict";

exports.__esModule = true;
exports.default = void 0;
var _createSizePropertyCheck = _interopRequireDefault(require("./_createSizePropertyCheck.js"));
var _getByteLength = _interopRequireDefault(require("./_getByteLength.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Internal helper to determine whether we should spend extensive checks against
// `ArrayBuffer` et al.
var _default = exports.default = (0, _createSizePropertyCheck.default)(_getByteLength.default);